var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';

var MarkerHeart = function MarkerHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 47",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "MarkerHeart_a",
    d: "M225 1830c-3.31 0-6 1.12-6 2.5s2.69 2.5 6 2.5 6-1.12 6-2.5-2.69-2.5-6-2.5z"
  }), React.createElement("path", {
    id: "MarkerHeart_b",
    d: "M225 1788c-8.3 0-15 6.89-15 15.4 0 11.55 15 28.6 15 28.6s15-17.05 15-28.6c0-8.51-6.7-15.4-15-15.4"
  }), React.createElement("path", {
    id: "MarkerHeart_c",
    d: "M224.53 1812.25l-6.84-6.26a4.99 4.99 0 0 1 0-7.5c1.1-.99 2.6-1.52 4.15-1.46 1.21.04 2.4.43 3.37 1.1a6.41 6.41 0 0 1 3.37-1.1 5.84 5.84 0 0 1 4.14 1.46 4.99 4.99 0 0 1 0 7.5l-6.83 6.25a1.02 1.02 0 0 1-1.35 0zm7.28-8.95c.24 0 .44-.19.44-.42 0-.24-.2-.43-.44-.43h-3.73l-1.62-2.26a.47.47 0 0 0-.4-.19.45.45 0 0 0-.35.25l-1.61 3.36-1.09-2.15a.4.4 0 0 0-.37-.22.44.44 0 0 0-.39.2l-.61 1h-3.04c-.24 0-.43.2-.43.44 0 .22.2.42.43.42h3.29c.15 0 .3-.08.37-.22l.34-.54 1.14 2.23c.07.13.22.23.39.23.16 0 .31-.1.39-.24l1.66-3.5 1.32 1.86c.08.11.22.18.36.18h3.95"
  })), React.createElement("use", {
    fill: "#6f7070",
    xlinkHref: "#MarkerHeart_a",
    opacity: 0.4,
    transform: "translate(-210 -1788)"
  }), React.createElement("use", {
    fill: "#ff5d58",
    xlinkHref: "#MarkerHeart_b",
    transform: "translate(-210 -1788)"
  }), React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#MarkerHeart_c",
    transform: "translate(-210 -1788)"
  }));
};

export default MarkerHeart;